import React, { Component } from 'react';
import { Col } from 'react-bootstrap';


class Add9 extends Component {

  render() {
    return (
      <Col lg={ 4 } className="add Add9">
        <h4> Add9 </h4>
      </Col>
    )
  }
}

export default Add9;
